
<template>
  <v-content>
    <v-container
      fluid>
      <v-signup-card
        v-model="inputValue"
        :errorMessage="errorMessage"
        @submit-button-click="signup"/>
      <v-row
        no-gutters
        align=center
        justify=center>
        <v-col
          md=8
          sm=10>
          <v-container
            fluid>
            <v-row
              no-gutters
              justify="space-between"
              >
              <v-col
                cols="auto">
                <v-btn
                  class="main--text"
                  rounded
                  outlined
                  :to="'top'"
                  >
                  トップへ
                </v-btn>
              </v-col>
              <v-col
                cols="auto">
                <v-btn
                  class="main--text"
                  rounded
                  outlined
                  @click="$router.push('/teacher/top')"
                >教師の方はこちら
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    <v-signup-dialog
      :enable="dialog"
      :inProgress="inProgress"
      @resend-button-click="resendEmail"
      @finish-button-click="toLogin"
    />
    </v-container>
  </v-content>
</template>

<script>
import { auth } from '@/auth/client/firebase'
import { firestore } from "@/repository/client/firestore"
import { AuthService } from "@/service/auth/auth"
import VSignupCard from "@/components/organisms/parent/VSignupCard.vue"
import VSignupDialog from "@/components/organisms/parent/VSignupDialog.vue"

export default {
  components: {
    VSignupCard,
    VSignupDialog
  },
  data() {
    return {
      inputValue: {
        email: "",
        password: "",
        confirmPassword: ""
      },
      dialog: false,
      inProgress: true,
      user: null,
      errorMessage: null
    }
  },
  methods: {
    signup: async function() {
      this.dialog = true
      try {
        this.user = await this.authService.createUser(this.inputValue.email, this.inputValue.password, process.env.VUE_APP_PARENT_SIGNUPED_URL)
        this.inProgress = false
      } catch (e) {
        this.dialog = false
        this.errorMessage = e.message
      }
    },
    resendEmail: async function () {
      this.inProgress = true
      await this.authService.deleteUser(this.inputValue.email, this.inputValue.password)
      try {
        this.user = this.authService.resendVerifyMail(this.inputValue.email, this.inputValue.password, process.env.VUE_APP_PARENT_SIGNUPED_URL)
        this.inProgress = false
      } catch (e) {
        this.dialog = false
        this.errorMessage = e.message
      }
    },
    toLogin: function() {
      this.$store.commit("loginAsParent", )
      this.$router.push({name: "parentTop"})
    }
  },
  created: function () {
    this.authService = new AuthService(auth, firestore)
  }
}
</script>

<style scoped>

.white-text {
  color: white;
}

.error-message {
  color: red;
  font-family: 'M PLUS Rounded 1c', sans-serif;
}
</style>
